import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet-async';
import { themeGet } from 'styled-system';
import { Heading, Button, Flex, Box, Image } from 'roo-ui/components';
import { alertIllustration } from 'roo-ui/assets';

const StyledAlertIllustration = styled(Image)`
  margin-bottom: ${themeGet('space.8')};
  width: ${themeGet('space.15')};
`;

const BackButton = styled(Button)`
  background-color: ${themeGet('colors.brand.primary')};
  margin-top: ${themeGet('space.8')};
  padding-left: ${themeGet('space.12')};
  padding-right: ${themeGet('space.12')};
`;

BackButton.displayName = 'BackButton';

const goBack = () => {
  window.history.back();
};

const FourOhFourPage = () => (
  <Fragment>
    <Helmet title="Nothing found | Qantas Hotels Australia" />
    <Flex p={4} justifyContent="center" alignItems="center" flexDirection="column" textAlign="center" minHeight={600}>
      <StyledAlertIllustration src={alertIllustration} />
      <Heading.h2> Oops, we can&#39;t find the page you were looking for</Heading.h2>
      <Heading.h4>It looks like we may have moved the page, or it may not exist anymore.</Heading.h4>
      <Box>
        <BackButton onClick={goBack}> go back </BackButton>
      </Box>
    </Flex>
  </Fragment>
);

export default FourOhFourPage;
